import { store, type AppState } from '@/state/store';

// ═══════════════════════════════════════════════════════════════
// Stavový řádek (sekce 2.5): počet slov, stav uložení, zoom.
// ═══════════════════════════════════════════════════════════════

export class StatusBar {
  private root: HTMLElement;
  private wordsEl!: HTMLElement;
  private saveEl!: HTMLElement;
  private zoomEl!: HTMLElement;

  constructor(mount: HTMLElement, private onZoom: (z: number) => void) {
    this.root = document.createElement('footer');
    this.root.className = 'status-bar';
    this.build();
    mount.appendChild(this.root);
    store.subscribe((s) => this.render(s));
  }

  private build() {
    this.root.innerHTML = `
      <div class="status-left">
        <span class="status-words">0 slov</span>
        <span class="status-lang">Čeština (Česko)</span>
      </div>
      <div class="status-right">
        <span class="status-save"></span>
        <div class="status-zoom">
          <button class="zoom-btn" data-z="out">−</button>
          <span class="zoom-val">100 %</span>
          <button class="zoom-btn" data-z="in">+</button>
        </div>
      </div>`;
    this.wordsEl = this.root.querySelector('.status-words')!;
    this.saveEl = this.root.querySelector('.status-save')!;
    this.zoomEl = this.root.querySelector('.zoom-val')!;

    this.root.querySelector('[data-z="out"]')!.addEventListener('click', () => this.step(-0.1));
    this.root.querySelector('[data-z="in"]')!.addEventListener('click', () => this.step(0.1));
  }

  private step(d: number) {
    const z = Math.min(2, Math.max(0.5, +(store.get().zoom + d).toFixed(2)));
    this.onZoom(z);
  }

  private render(s: AppState) {
    this.wordsEl.textContent = `${s.wordCount} ${plural(s.wordCount)}`;
    this.zoomEl.textContent = `${Math.round(s.zoom * 100)} %`;

    const map: Record<string, string> = {
      idle: s.doc.dirty ? 'Neuloženo' : '',
      saving: 'Ukládání…',
      saved: s.doc.lastSavedAt ? `Uloženo ${time(s.doc.lastSavedAt)}` : 'Uloženo',
      error: 'Uložení selhalo',
    };
    this.saveEl.textContent = map[s.saveStatus] || '';
    this.saveEl.classList.toggle('status-error', s.saveStatus === 'error');
  }
}

function plural(n: number): string {
  if (n === 1) return 'slovo';
  if (n >= 2 && n <= 4) return 'slova';
  return 'slov';
}

function time(ts: number): string {
  return new Date(ts).toLocaleTimeString('cs-CZ', { hour: '2-digit', minute: '2-digit' });
}
